export default {
  recoveriesLoading: false,
  advanceRecoveries: []
}
